import * as v from 'valibot';

export const Reason = v.object({
	id: v.number(),
	reason: v.string(),
});

export type Reason = v.InferOutput<typeof Reason>;

export const Reasons = v.array(
	v.object({
		type: v.picklist(['Closure', 'Reopen', 'Reject', 'SalesRejection']),
		reasons: v.array(Reason),
	}),
);

export type Reasons = v.InferOutput<typeof Reasons>;
